module.exports = __webpack_public_path__ + "img/empty3.57df0b6a.png";